export default __webpack_public_path__ + "static/media/logo-real.d0ee5e7e.png";